export default __webpack_public_path__ + "static/media/FICHA TÉCNICA- MELANCIA.6f25ee80.pdf";